import type {FetchPaymentWaysResponse} from '../../http';
import {fetchPaymentWays} from '../../http';
import {useQuery, type UseQueryOptions} from 'react-query';

export function useFetchPaymentWays(options?: UseQueryOptions<FetchPaymentWaysResponse>) {
	return useQuery<FetchPaymentWaysResponse>({
		queryKey: ['paymentWays'],
		queryFn: async ({signal}) => {
			const {data} = await fetchPaymentWays(signal);

			return data;
		},
		...options,
	});
}
